import { OnboardingModel } from "../model/OnboardingModel";
import CreateCorporate from "./controlPanel/CreateCorporate";
type List = {
  label: string;
  value: string;
};
type OnboardinProps = {
  data?: OnboardingModel;
};
const Onboarding = ({ data }: OnboardinProps) => {
  return (
    <>
      <main
        className="grow h-full d-flex content px-4 registration-sec"
        id="content"
        role="content"
      >
        <div className="card m-auto  onboarding-form">
        <CreateCorporate
          heading="Registration Form"
          logo="media/images/ewts-logo.png"
        />
        </div>
      </main>
    </>
  );
};

export default Onboarding;
